export const PAYMENT_SUCCESSFUL = 'gpWebpay.paymentSuccessful';
export const PAYMENT_CANCELED_BY_USER = 'gpWebpay.paymentCanceledByUser';
export const PAYMENT_DECLINED = 'gpWebpay.paymentDeclined';
export const PAYMENT_EXPIRED_CARD = 'gpWebpay.expiredCard';
export const PAYMENT_EXPIRED = 'gpWebpay.paymentExpired';
export const TECHNICAL_PROBLEM = 'gpWebpay.technicalProblem';
